import React from 'react';
import { Box } from '@mui/material';

// Single source of truth for rupee formatting. The app formats money ~112
// places with hand-rolled toLocaleString('en-IN') calls; use these instead.

// formatINR(x) -> "₹1,234" — for strings (SMS / WhatsApp / print templates).
export function formatINR(value, { decimals = 0 } = {}) {
  const n = parseFloat(value);
  if (Number.isNaN(n)) return '₹0';
  return '₹' + n.toLocaleString('en-IN', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
}

// <Money value={x} /> — for JSX. Accepts any Box/Typography sx props.
export default function Money({ value, decimals = 0, ...props }) {
  return (
    <Box component="span" {...props}>
      {formatINR(value, { decimals })}
    </Box>
  );
}
